import {Contract} from 'web3-eth-contract'
import stakeAbi from './abi/stake.json'

export interface TokenInterFace {
    address: { [key: string]: string },
    useAddr:string,
    nick: string,
    contract: Contract,
    balance?: string,

}
export interface ChangeInterFace {
    address: string,
    contract: Contract,
}


export const  USDT = 'usdt';
export const NSURE = 'nsure'

export const TokenList: any = {
    nsure: {
        address: {
            1: '0x20945ca1df56d237fd40036d47e866c7dccd2114',
            42: '0xEf729dA236Fa560319b9AcEf939c081fEc41c12C',
        },
        nick: 'Nsure',
    },
}


export const ChangeMap:any = {


}

export const ContractMap: any = {

    stakeContract: {
        1: '0xfd0D28539aeD12477dcba1575eB40fca53969440',
        42: '0x2E64489F16Ec1cB7131EE4c37e5044799fBcFbd2',
        abi: stakeAbi.abi
    },

}
